import { GetStaticPaths } from 'next'
import { NextPageWithLayout } from '@/layouts'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'

const CatchAllPage: NextPageWithLayout = () => {
  return <div className="bg-950 fixed inset-0" />
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/[...parts].tsx' },
  async ({ next404 }) => {
    return next404()
  },
)

CatchAllPage.getLayout = (page) => page

export default CatchAllPage
